<section class="workflow-selector">
	<div class="workflow-header">
		<h3 i18n="WorkflowSelectInstructionsTitle"
			>Select print material delivery method from the available options</h3
		>
		<p i18n="WorkflowSelectInstructionsDescription"
			>To print what you need, we need print material made according to our guidelines. Select a suitable
			delivery method from the available options.</p
		>
	</div>

	<nav
		fxLayout="column"
		class="workflow-list"
		gdRows="1fr"
		gdColumns="1fr"
		gdColumns.gt-xs="1fr 1fr"
		gdGap="20px"
	>
		<button
			type="button"
			class="workflow"
			*ngFor="let workflow of workflows"
			[ngClass]="{ active: workflow.key === selectedWorkflow?.key }"
			(click)="onSelectWorkflow(workflow, $event)"
		>
			<div fxLayout="row" fxLayoutGap="28px" fxLayoutAlign="center">
				<div class="workflow-icon">
					<g-icon
						[icon]="workflow.key === selectedWorkflow?.key ? workflow.iconActive : workflow.icon"
					/>
				</div>
				<div class="workflow-text" fxFlex="auto">
					<h5>{{ translated.string(workflow.title) }}</h5>
					<div class="workflow-description">{{ translated.string(workflow.description) }}</div>
				</div>
			</div>
		</button>
	</nav>
</section>
